import styled from 'styled-components';
import Button from 'ui/atoms/button';

export const SubmitButton = styled(Button)`
  margin-bottom: 1rem;
`;
